export const preventEvent = (e: Event) => e.preventDefault();
